import script from "./AutorsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorsTable.vue?vue&type=script&setup=true&lang=js"

import "./AutorsTable.vue?vue&type=style&index=0&id=2c065558&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c065558"]])

export default __exports__